{
  "INTEGRATION_SETTINGS": {
    "SHOPIFY": {
      "HEADER": "Shopify",
      "DELETE": {
        "TITLE": "Elimina Integrazione Shopify",
        "MESSAGE": "Sei sicuro di voler eliminare l'integrazione Shopify?"
      },
      "STORE_URL": {
        "TITLE": "Connetti Store Shopify",
        "LABEL": "URL Store",
        "PLACEHOLDER": "your-store.myshopify.com",
        "HELP": "Inserisci l'URL del tuo store Shopify myshopify.com",
        "CANCEL": "Annulla",
        "SUBMIT": "Connetti Store"
      },
      "ERROR": "Si è verificato un errore nella connessione a Shopify. Si prega di riprovare o contattare il supporto se il problema persiste."
    },
    "HEADER": "Integrazioni",
    "DESCRIPTION": "Chatwoot si integra con più strumenti e servizi per migliorare l'efficienza del tuo team. Esplora l'elenco qui sotto per configurare le tue app preferite.",
    "LEARN_MORE": "Scopri di più sulle integrazioni",
    "LOADING": "Caricamento integrazioni",
    "SEARCH_PLACEHOLDER": "Cerca integrazioni...",
    "NO_RESULTS": "Nessuna integrazione trovata corrispondente alla tua ricerca",
    "CAPTAIN": {
      "DISABLED": "Captain non è abilitato sul tuo account.",
      "CLICK_HERE_TO_CONFIGURE": "Clicca qui per configurare",
      "LOADING_CONSOLE": "Caricamento Console Captain...",
      "FAILED_TO_LOAD_CONSOLE": "Caricamento della Console Captain non riuscito. Aggiorna e riprova."
    },
    "WEBHOOK": {
      "SUBSCRIBED_EVENTS": "Eventi Sottoscritti",
      "LEARN_MORE": "Scopri di più sui webhooks",
      "SECRET": {
        "LABEL": "Secret",
        "COPY": "Copia secret negli appunti",
        "COPY_SUCCESS": "Secret copiato negli appunti",
        "TOGGLE": "Cambia visibilità secret",
        "CREATED_DESC": "Il tuo webhook è stato creato. Usa il secret qui sotto per verificare le signature del webhook. Per favore copialo ora — lo puoi ritrovare più tardi nel modulo di modifica webhook.",
        "DONE": "Fatto"
      },
      "COUNT": "{n} webhook | {n} webhook",
      "SEARCH_PLACEHOLDER": "Cerca webhook...",
      "NO_RESULTS": "Nessun webhook trovato corrispondente alla tua ricerca",
      "FORM": {
        "CANCEL": "Annulla",
        "DESC": "Gli eventi Webhook ti forniscono le informazioni in tempo reale su ciò che sta accadendo nel tuo account Chatwoot. Per favore inserisci un URL valido per configurare un callback.",
        "SUBSCRIPTIONS": {
          "LABEL": "Eventi",
          "EVENTS": {
            "CONVERSATION_CREATED": "Conversazione Creata",
            "CONVERSATION_STATUS_CHANGED": "Stato conversazione cambiato",
            "CONVERSATION_UPDATED": "Conversazione aggiornata",
            "MESSAGE_CREATED": "Messaggio creato",
            "MESSAGE_UPDATED": "Messaggio aggiornato",
            "WEBWIDGET_TRIGGERED": "Widget live chat aperto dall'utente",
            "CONTACT_CREATED": "Contatto creato",
            "CONTACT_UPDATED": "Contatto aggiornato",
            "CONVERSATION_TYPING_ON": "Digitazione conversazione attiva",
            "CONVERSATION_TYPING_OFF": "Digitazione conversazione disattiva",
            "INBOX_UPDATED": "Inbox updated"
          }
        },
        "NAME": {
          "LABEL": "Nome Webhook",
          "PLACEHOLDER": "Inserisci un nome per il webhook"
        },
        "END_POINT": {
          "LABEL": "URL del webhook",
          "PLACEHOLDER": "Example: {webhookExampleURL}",
          "ERROR": "Inserisci un URL valido"
        },
        "EDIT_SUBMIT": "Aggiorna webhook",
        "ADD_SUBMIT": "Crea webhook"
      },
      "TITLE": "Webhook",
      "CONFIGURE": "Configura",
      "HEADER": "Impostazioni Webhook",
      "HEADER_BTN_TXT": "Aggiungi nuovo webhook",
      "LOADING": "Recupero dei webhooks collegati",
      "SEARCH_404": "Non ci sono elementi che corrispondono a questa richiesta",
      "SIDEBAR_TXT": "<p><b>Webhooks</b> </p> <p>I Webhooks sono callback HTTP che possono essere definiti per ogni account. Sono innescati da eventi come la creazione di messaggi in Chatwoot. Puoi creare più di un webhook per questo account. <br /><br /> Per creare un <b>webhook</b>, clicca sul pulsante <b>Aggiungi nuovo webhook</b>. Puoi anche rimuovere qualsiasi webhook esistente cliccando sul pulsante Elimina.</p>",
      "LIST": {
        "404": "Non ci sono webhook configurati per questo account.",
        "TITLE": "Gestisci webhook",
        "TABLE_HEADER": {
          "WEBHOOK_ENDPOINT": "Endpoint Webhook",
          "ACTIONS": "Azioni"
        }
      },
      "EDIT": {
        "BUTTON_TEXT": "Modifica",
        "TITLE": "Modifica webhook",
        "API": {
          "SUCCESS_MESSAGE": "Configurazione Webhook aggiornata correttamente",
          "ERROR_MESSAGE": "Impossibile connettersi al server Woot, riprova più tardi"
        }
      },
      "ADD": {
        "CANCEL": "Annulla",
        "TITLE": "Aggiungi nuovo webhook",
        "API": {
          "SUCCESS_MESSAGE": "Configurazione Webhook aggiunta correttamente",
          "ERROR_MESSAGE": "Impossibile connettersi al server Woot, riprova più tardi"
        }
      },
      "DELETE": {
        "BUTTON_TEXT": "Elimina",
        "API": {
          "SUCCESS_MESSAGE": "Webhook eliminato con successo",
          "ERROR_MESSAGE": "Impossibile connettersi al server Woot, riprova più tardi"
        },
        "CONFIRM": {
          "TITLE": "Conferma Eliminazione",
          "MESSAGE": "Sei sicuro di voler eliminare il webhook? ({webhookURL})",
          "YES": "Sì, Elimina ",
          "NO": "No, Conserva"
        }
      }
    },
    "SLACK": {
      "HEADER": "Slack",
      "DELETE": "Elimina",
      "DELETE_CONFIRMATION": {
        "TITLE": "Elimina l'integrazione",
        "MESSAGE": "Sei sicuro di voler eliminare l'integrazione? Così facendo si perderà l'accesso alle conversazioni nel tuo workspace Slack."
      },
      "HELP_TEXT": {
        "TITLE": "Stai utilizzando l'integrazione Slack",
        "BODY": "Con questa integrazione, tutte le conversazioni in arrivo verranno sincronizzate nel canale ***{selectedChannelName}*** del tuo workspace Slack. Potrai gestire tutte le conversazioni con i clienti direttamente dal canale e non perderai mai un messaggio.\n\nEcco le principali funzionalità dell’integrazione:\n\n**Rispondi alle conversazioni direttamente da Slack:** Per rispondere a una conversazione nel canale Slack ***{selectedChannelName}***, ti basta scrivere il tuo messaggio e inviarlo come thread. Questo invierà automaticamente la risposta al cliente tramite Chatwoot. Semplice!\n\n**Crea note private:** Se vuoi aggiungere note private invece di risposte, inizia il messaggio con ***`note:`***. In questo modo il messaggio resterà privato e non sarà visibile al cliente.\n\n**Associa un profilo operatore:** Se la persona che risponde su Slack ha un profilo operatore in app con lo stesso indirizzo email, le risposte verranno associate automaticamente a quel profilo. In questo modo potrai sapere facilmente chi ha risposto e quando. Se invece chi risponde non ha un profilo operatore associato, le risposte verranno inviate al cliente dal profilo del bot.",
        "SELECTED": "selezionato"
      },
      "SELECT_CHANNEL": {
        "OPTION_LABEL": "Seleziona un canale",
        "UPDATE": "Aggiorna",
        "BUTTON_TEXT": "Connetti canale",
        "DESCRIPTION": "Il tuo workspace Slack è ora collegato a Chatwoot. Tuttavia, l'integrazione è attualmente inattiva. Per attivare l'integrazione e collegare un canale a Chatwoot, fare clic sul pulsante qui sotto.\n\n**Nota:** Se stai tentando di collegare un canale privato, aggiungi l'app Chatwoot al canale Slack prima di procedere con questo passaggio.",
        "ATTENTION_REQUIRED": "Attenzione richiesta",
        "EXPIRED": "La tua integrazione con Slack è scaduta. Per continuare a ricevere messaggi su Slack, elimina l'integrazione e connetti nuovamente il tuo workspace."
      },
      "UPDATE_ERROR": "Si è verificato un errore durante l'aggiornamento dell'integrazione, riprova",
      "UPDATE_SUCCESS": "Il canale è connesso con successo",
      "FAILED_TO_FETCH_CHANNELS": "Si è verificato un errore nel recupero dei canali da Slack, per favore riprova"
    },
    "DYTE": {
      "CLICK_HERE_TO_JOIN": "Clicca qui per unirti",
      "LEAVE_THE_ROOM": "Lascia la stanza",
      "START_VIDEO_CALL_HELP_TEXT": "Avvia una nuova videochiamata con il cliente",
      "JOIN_ERROR": "Si è verificato un errore nell'unirsi alla chiamata, riprova",
      "CREATE_ERROR": "Si è verificato un errore durante la creazione di un link alla riunione, riprova"
    },
    "OPEN_AI": {
      "AI_ASSIST": "AI Assist",
      "WITH_AI": " {option} con l'AI ",
      "OPTIONS": {
        "REPLY_SUGGESTION": "Suggerimenti di Risposta",
        "SUMMARIZE": "Riassumi",
        "REPHRASE": "Migliora la Scrittura",
        "FIX_SPELLING_GRAMMAR": "Correggi ortografia e grammatica",
        "SHORTEN": "Abbrevia",
        "EXPAND": "Espandi",
        "MAKE_FRIENDLY": "Cambia il tono del messaggio in amichevole",
        "MAKE_FORMAL": "Usa un tono formale",
        "SIMPLIFY": "Semplifica",
        "CONFIDENT": "Usa un tono sicuro",
        "PROFESSIONAL": "Usa un tono professionale",
        "CASUAL": "Usa un tono informale",
        "STRAIGHTFORWARD": "Usa un tono diretto"
      },
      "REPLY_OPTIONS": {
        "IMPROVE_REPLY": "Migliora la risposta",
        "IMPROVE_REPLY_SELECTION": "Migliora il testo selezionato",
        "CHANGE_TONE": {
          "TITLE": "Cambia tono",
          "OPTIONS": {
            "PROFESSIONAL": "Professionale",
            "CASUAL": "Informale",
            "STRAIGHTFORWARD": "Diretto",
            "CONFIDENT": "Sicuro",
            "FRIENDLY": "Amichevole"
          }
        },
        "GRAMMAR": "Correggi grammatica e ortografia",
        "SUGGESTION": "Suggerisci una risposta",
        "SUMMARIZE": "Riassumi la conversazione",
        "ASK_COPILOT": "Chiedi a Copilot"
      },
      "ASSISTANCE_MODAL": {
        "DRAFT_TITLE": "Contenuti in bozza",
        "GENERATED_TITLE": "Contenuti generati",
        "AI_WRITING": "L'AI sta scrivendo",
        "BUTTONS": {
          "APPLY": "Usa questo suggerimento",
          "CANCEL": "Annulla"
        }
      },
      "CTA_MODAL": {
        "TITLE": "Integra con OpenAI",
        "DESC": "Porta funzionalità AI avanzate nella tua dashboard con i modelli GPT di OpenAI. Per iniziare, inserisci la chiave API dal tuo account OpenAI.",
        "KEY_PLACEHOLDER": "Inserisci la tua chiave API OpenAI",
        "BUTTONS": {
          "NEED_HELP": "Hai bisogno di aiuto?",
          "DISMISS": "Ignora",
          "FINISH": "Completa Setup"
        },
        "DISMISS_MESSAGE": "Puoi configurare l'integrazione di OpenAI più tardi quando vuoi.",
        "SUCCESS_MESSAGE": "Setup integrazione OpenAI completato con successo"
      },
      "TITLE": "Migliora con AI",
      "SUMMARY_TITLE": "Riassunto con AI",
      "REPLY_TITLE": "Suggerimenti di risposta con AI",
      "SUBTITLE": "Una risposta migliorata verrà generata utilizzando l'AI, in base alla tua bozza attuale.",
      "TONE": {
        "TITLE": "Tono",
        "OPTIONS": {
          "PROFESSIONAL": "Professionale",
          "FRIENDLY": "Amichevole"
        }
      },
      "BUTTONS": {
        "GENERATE": "Genera",
        "GENERATING": "Generazione...",
        "CANCEL": "Annulla"
      },
      "GENERATE_ERROR": "Si è verificato un errore nell'elaborazione del contenuto, verifica la tua chiave API OpenAI e riprova"
    },
    "DELETE": {
      "BUTTON_TEXT": "Elimina",
      "API": {
        "SUCCESS_MESSAGE": "Integrazione eliminata con successo"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "Connetti"
    },
    "DASHBOARD_APPS": {
      "TITLE": "App Dashboard",
      "HEADER_BTN_TXT": "Aggiungi una nuova App Dashboard",
      "SIDEBAR_TXT": "<p><b>App dashboard</b></p><p>Le app dashboard consentono alle organizzazioni di incorporare un'applicazione all'interno di Chatwoot per fornire informazioni aggiuntive agli operatorii. Questa funzione consente di creare un'applicazione in modo indipendente e incorporata all'interno della dashboard per fornire informazioni degli utenti, ad esempio ordini o pagamenti effettuati.</p><p>Quando integri la tua applicazione usando la dashboard Chatwoot, la tua applicazione avrà il context della conversazione e del contatto come evento window. Implementa un listener per l'evento del messaggio sulla tua pagina per ricevere i dati.</p><p>Per aggiungere una nuova app dashboard, clicca sul pulsante 'Aggiungi una nuova app dashboard'.</p>",
      "DESCRIPTION": "Le app dashboard consentono alle organizzazioni di incorporare un'applicazione all'interno della dashboard per fornire dati aggiuntivi agli operatori. Questa funzione consente di creare un'applicazione in modo indipendente e incorporarla per fornire informazioni sull'utente, i suoi ordini o la loro cronologia di pagamento precedente.",
      "LEARN_MORE": "Scopri di più sulle App Dashboard",
      "COUNT": "{n} app dashboard | {n} app dashboard",
      "SEARCH_PLACEHOLDER": "Cerca app dashboard...",
      "NO_RESULTS": "Nessuna app dashboard trovata corrispondente alla tua ricerca",
      "LIST": {
        "404": "Non ci sono ancora app dashboard configurate su questo account",
        "LOADING": "Caricamento app dashboard...",
        "TABLE_HEADER": {
          "NAME": "Nome",
          "ENDPOINT": "Endpoint",
          "ACTIONS": "Azioni"
        },
        "EDIT_TOOLTIP": "Modifica app",
        "DELETE_TOOLTIP": "Elimina app"
      },
      "FORM": {
        "TITLE_LABEL": "Nome",
        "TITLE_PLACEHOLDER": "Inserisci un nome per la tua app dashboard",
        "TITLE_ERROR": "È richiesto un nome per l'app dashboard",
        "URL_LABEL": "Endpoint",
        "URL_PLACEHOLDER": "Inserisci l'URL dell'endpoint dove la tua app è hostata",
        "URL_ERROR": "È richiesto un URL valido"
      },
      "CREATE": {
        "HEADER": "Aggiungi una nuova App Dashboard",
        "FORM_SUBMIT": "Invia",
        "FORM_CANCEL": "Annulla",
        "API_SUCCESS": "App dashboard configurata con successo",
        "API_ERROR": "Non siamo riusciti a creare un'app. Riprova più tardi"
      },
      "UPDATE": {
        "HEADER": "Modifica app dashboard",
        "FORM_SUBMIT": "Aggiorna",
        "FORM_CANCEL": "Annulla",
        "API_SUCCESS": "App dashboard aggiornata con successo",
        "API_ERROR": "Non è stato possibile aggiornare l'app. Riprova più tardi"
      },
      "DELETE": {
        "CONFIRM_YES": "Sì, elimina",
        "CONFIRM_NO": "No, mantieni",
        "TITLE": "Conferma eliminazione",
        "MESSAGE": "Sei sicuro di voler eliminare l'app - {appName}?",
        "API_SUCCESS": "App dashboard cancellata con successo",
        "API_ERROR": "Non è stato possibile eliminare l'app. Riprova più tardi"
      }
    },
    "LINEAR": {
      "HEADER": "Linear",
      "ADD_OR_LINK_BUTTON": "Crea/collega issue Linear",
      "LOADING": "Caricamento issue Linear...",
      "LOADING_ERROR": "Si è verificato un errore nel recupero delle issue Linear, si prega di riprovare",
      "CREATE": "Crea",
      "LINK": {
        "SEARCH": "Cerca issue",
        "SELECT": "Seleziona issue",
        "TITLE": "Link",
        "EMPTY_LIST": "Nessuna issue Linear trovata",
        "LOADING": "Caricamento",
        "ERROR": "Si è verificato un errore nel recupero delle issue Linear, si prega di riprovare",
        "LINK_SUCCESS": "Issue collegata con successo",
        "LINK_ERROR": "Si è verificato un errore durante il collegamento della issue, per favore riprova",
        "LINK_TITLE": "Conversazione (#{conversationId}) con {name}"
      },
      "ADD_OR_LINK": {
        "TITLE": "Crea/collega issue Linear",
        "DESCRIPTION": "Creare issue Linear dalle conversazioni, o collega quelle esistenti per un monitoraggio costante.",
        "FORM": {
          "TITLE": {
            "LABEL": "Titolo",
            "PLACEHOLDER": "Inserisci titolo",
            "REQUIRED_ERROR": "Titolo richiesto"
          },
          "DESCRIPTION": {
            "LABEL": "Descrizione",
            "PLACEHOLDER": "Inserisci descrizione"
          },
          "TEAM": {
            "LABEL": "Team",
            "PLACEHOLDER": "Seleziona team",
            "SEARCH": "Cerca team",
            "REQUIRED_ERROR": "Team richiesto"
          },
          "ASSIGNEE": {
            "LABEL": "Assegnatario",
            "PLACEHOLDER": "Seleziona assegnatario",
            "SEARCH": "Cerca assegnatario"
          },
          "PRIORITY": {
            "LABEL": "Priorità",
            "PLACEHOLDER": "Seleziona priorità",
            "SEARCH": "Cerca priorità"
          },
          "LABEL": {
            "LABEL": "Etichetta",
            "PLACEHOLDER": "Seleziona etichetta",
            "SEARCH": "Cerca etichetta"
          },
          "STATUS": {
            "LABEL": "Stato",
            "PLACEHOLDER": "Seleziona stato",
            "SEARCH": "Cerca stato"
          },
          "PROJECT": {
            "LABEL": "Progetto",
            "PLACEHOLDER": "Seleziona progetto",
            "SEARCH": "Cerca progetto"
          }
        },
        "CREATE": "Crea",
        "CANCEL": "Annulla",
        "CREATE_SUCCESS": "Issue creata con successo",
        "CREATE_ERROR": "Si è verificato un errore durante la creazione della issue, per favore riprova",
        "LOADING_TEAM_ERROR": "Si è verificato un errore nel caricamento dei team, riprova",
        "LOADING_TEAM_ENTITIES_ERROR": "Si è verificato un errore nel caricamento delle entità dei team, riprova"
      },
      "ISSUE": {
        "STATUS": "Stato",
        "PRIORITY": "Priorità",
        "ASSIGNEE": "Assegnatario",
        "LABELS": "Etichette",
        "CREATED_AT": "Creato {createdAt}"
      },
      "UNLINK": {
        "TITLE": "Disconnetti",
        "SUCCESS": "Issue scollegata con successo",
        "ERROR": "Si è verificato un errore durante lo scollegamento della issue, riprova"
      },
      "NO_LINKED_ISSUES": "Nessuna issue collegata trovata",
      "DELETE": {
        "TITLE": "Sei sicuro di voler eliminare l'integrazione?",
        "MESSAGE": "Sei sicuro di voler eliminare l'integrazione?",
        "CONFIRM": "Sì, elimina",
        "CANCEL": "Annulla"
      },
      "CTA": {
        "TITLE": "Connetti a Linear",
        "AGENT_DESCRIPTION": "Il workspace di Linear non è connesso. Richiedi all'amministratore di connettere un workspace per utilizzare questa integrazione.",
        "DESCRIPTION": "Il workspace di Linear non è connesso. Fai clic sul pulsante qui sotto per collegare il workspace per utilizzare questa integrazione.",
        "BUTTON_TEXT": "Connetti workspace Linear"
      }
    },
    "NOTION": {
      "HEADER": "Notion",
      "DELETE": {
        "TITLE": "Sei sicuro di voler eliminare l'integrazione di Notion?",
        "MESSAGE": "L'eliminazione di questa integrazione rimuoverà l'accesso al tuo workspace Notion e interromperà tutte le funzionalità correlate.",
        "CONFIRM": "Sì, elimina",
        "CANCEL": "Annulla"
      }
    }
  },
  "CAPTAIN": {
    "NAME": "Captain",
    "HEADER_KNOW_MORE": "Scopri di più",
    "ASSISTANT_SWITCHER": {
      "ASSISTANTS": "Assistenti",
      "SWITCH_ASSISTANT": "Cambia assistenti",
      "NEW_ASSISTANT": "Crea Assistente",
      "EMPTY_LIST": "Nessun assistente trovato, creane uno per iniziare"
    },
    "COPILOT": {
      "TITLE": "Copilot",
      "TRY_THESE_PROMPTS": "Prova questi prompt",
      "PANEL_TITLE": "Inizia a usare Copilot",
      "KICK_OFF_MESSAGE": "Hai bisogno di un riassunto rapido, vuoi controllare le conversazioni passate o vuoi scrivere risposte migliori? Copilot è qui per te.",
      "SEND_MESSAGE": "Invia messaggio...",
      "EMPTY_MESSAGE": "Si è verificato un errore durante la generazione della risposta. Riprova.",
      "LOADER": "Captain sta pensando",
      "YOU": "Tu",
      "USE": "Usa questo",
      "RESET": "Reimposta",
      "SHOW_STEPS": "Mostra i passaggi",
      "SELECT_ASSISTANT": "Seleziona Assistente",
      "PROMPTS": {
        "SUMMARIZE": {
          "LABEL": "Riassumi questa conversazione",
          "CONTENT": "Riassumi i punti chiave discussi tra il cliente e l'operatore, compresi i dubbi, le domande del cliente e le soluzioni o risposte fornite dall'operatore"
        },
        "SUGGEST": {
          "LABEL": "Suggerisci una risposta",
          "CONTENT": "Analizzare la richiesta del cliente e prepara una risposta che risponda efficacemente ai suoi dubbi o domande. Assicurati che la risposta sia chiara, concisa e fornisca informazioni utili."
        },
        "RATE": {
          "LABEL": "Valuta questa conversazione",
          "CONTENT": "Valuta la conversazione per vedere quanto soddisfa le esigenze del cliente. Dai una valutazione da 1 a 5 in base al tono, alla chiarezza e all'efficacia."
        },
        "HIGH_PRIORITY": {
          "LABEL": "Conversazioni ad alta priorità",
          "CONTENT": "Dammi un riassunto di tutte le conversazioni aperte ad alta priorità. Includi l'ID della conversazione, il nome del cliente (se disponibile), il contenuto dell'ultimo messaggio e l'operatore assegnato. Raggruppa per stato se pertinente."
        },
        "LIST_CONTACTS": {
          "LABEL": "Elenca contatti",
          "CONTENT": "Mostrami l'elenco dei primi 10 contatti. Includi nome, email o numero di telefono (se disponibile), orario di ultima lettura, tag (se presenti)."
        }
      }
    },
    "PLAYGROUND": {
      "USER": "Tu",
      "ASSISTANT": "Assistente",
      "MESSAGE_PLACEHOLDER": "Scrivi il tuo messaggio...",
      "HEADER": "Area di prova",
      "DESCRIPTION": "Usa questo playground per inviare messaggi al tuo assistente e controllare se risponde correttamente, rapidamente e con il tono che ti aspetti.",
      "CREDIT_NOTE": "I messaggi inviati qui vengono scalati dai crediti Captain."
    },
    "PAYWALL": {
      "TITLE": "Aggiorna per usare Captain AI",
      "AVAILABLE_ON": "Captain non è disponibile sul piano gratuito.",
      "UPGRADE_PROMPT": "Aggiorna il tuo piano per ottenere l'accesso ai nostri assistenti, copilot e altro ancora.",
      "UPGRADE_NOW": "Aggiorna ora",
      "CANCEL_ANYTIME": "Puoi modificare o annullare il tuo piano in qualsiasi momento"
    },
    "ENTERPRISE_PAYWALL": {
      "AVAILABLE_ON": "Captain AI è disponibile solo nei piani Enterprise.",
      "UPGRADE_PROMPT": "Aggiorna il tuo piano per ottenere l'accesso ai nostri assistenti, copilot e altro ancora.",
      "ASK_ADMIN": "Contatta il tuo amministratore per l'aggiornamento."
    },
    "BANNER": {
      "RESPONSES": "Hai usato oltre l'80% del tuo limite di risposte. Per continuare a utilizzare Captain AI, per favore aggiorna.",
      "DOCUMENTS": "Raggiunto il limite di documenti. Aggiorna per continuare a usare Captain AI."
    },
    "FORM": {
      "CANCEL": "Annulla",
      "CREATE": "Crea",
      "EDIT": "Aggiorna"
    },
    "ASSISTANTS": {
      "HEADER": "Assistenti",
      "NO_ASSISTANTS_AVAILABLE": "Non ci sono assistenti disponibili nel tuo account.",
      "ADD_NEW": "Crea un nuovo assistente",
      "DELETE": {
        "TITLE": "Sei sicuro di voler eliminare l'assistente?",
        "DESCRIPTION": "Questa azione è permanente. L'eliminazione di questo assistente la rimuoverà da tutte le inbox connesse e cancellerà definitivamente tutte le knowledge generate.",
        "CONFIRM": "Sì, elimina",
        "SUCCESS_MESSAGE": "L'assistente è stato eliminato con successo",
        "ERROR_MESSAGE": "Si è verificato un errore durante l'eliminazione dell'assistente, riprova."
      },
      "FORM_DESCRIPTION": "Compila i dettagli qui sotto per dare un nome al tuo assistente, descriverne lo scopo e specificare il prodotto per cui offirà supporto.",
      "CREATE": {
        "TITLE": "Crea un assistente",
        "SUCCESS_MESSAGE": "L'assistente è stato creato correttamente",
        "ERROR_MESSAGE": "Si è verificato un errore durante la creazione dell'assistente, riprova."
      },
      "FORM": {
        "UPDATE": "Aggiorna",
        "SECTIONS": {
          "BASIC_INFO": "Informazioni di Base",
          "SYSTEM_MESSAGES": "System Messages",
          "INSTRUCTIONS": "Istruzioni",
          "FEATURES": "Funzionalità",
          "TOOLS": "Strumenti "
        },
        "NAME": {
          "LABEL": "Nome",
          "PLACEHOLDER": "Inserisci il nome dell'assistente",
          "ERROR": "Il nome è richiesto"
        },
        "TEMPERATURE": {
          "LABEL": "Temperatura della Risposta",
          "DESCRIPTION": "Regola quanto dovrebbero essere creative o restrittive le risposte dell'assistente. I valori più bassi producono risposte più mirate e deterministiche, mentre i valori più elevati consentono di ottenere risultati più creativi e variegati."
        },
        "DESCRIPTION": {
          "LABEL": "Descrizione",
          "PLACEHOLDER": "Inserisci la descrizione dell'assistente",
          "ERROR": "La descrizione è richiesta"
        },
        "PRODUCT_NAME": {
          "LABEL": "Nome Prodotto",
          "PLACEHOLDER": "Inserisci il nome del prodotto",
          "ERROR": "Il nome del prodotto è richiesto"
        },
        "WELCOME_MESSAGE": {
          "LABEL": "Messaggio di Benvenuto",
          "PLACEHOLDER": "Inserisci il messaggio di benvenuto"
        },
        "HANDOFF_MESSAGE": {
          "LABEL": "Messaggio di Handoff",
          "PLACEHOLDER": "Inserisci messaggio di handoff"
        },
        "RESOLUTION_MESSAGE": {
          "LABEL": "Messaggio di Risoluzione",
          "PLACEHOLDER": "Inserisci il messaggio di risoluzione"
        },
        "INSTRUCTIONS": {
          "LABEL": "Istruzioni",
          "PLACEHOLDER": "Inserisci le istruzioni per l'assistente"
        },
        "FEATURES": {
          "TITLE": "Funzionalità",
          "ALLOW_CONVERSATION_FAQS": "Genera FAQ dalle conversazioni risolte",
          "ALLOW_MEMORIES": "Salva memorie e dettagli chiave dalle interazioni con i clienti.",
          "ALLOW_CITATIONS": "Includi citazioni alle fonti nelle risposte",
          "ALLOW_CONTACT_ATTRIBUTES": "Consenti accesso alle informazioni di contatto"
        }
      },
      "EDIT": {
        "TITLE": "Aggiorna l'assistente",
        "SUCCESS_MESSAGE": "L'assistente è stato aggiornato correttamente",
        "ERROR_MESSAGE": "Si è verificato un errore durante l'aggiornamento dell'assistente, riprova.",
        "NOT_FOUND": "Impossibile trovare l'assistente. Riprova."
      },
      "SETTINGS": {
        "HEADER": "Impostazioni",
        "BASIC_SETTINGS": {
          "TITLE": "Impostazioni di base",
          "DESCRIPTION": "Personalizza ciò che l'assistente dice quando termina una conversazione o la trasferisce a un umano."
        },
        "SYSTEM_SETTINGS": {
          "TITLE": "Impostazioni di sistema",
          "DESCRIPTION": "Personalizza ciò che l'assistente dice quando termina una conversazione o la trasferisce a un umano."
        },
        "CONTROL_ITEMS": {
          "TITLE": "Impostazioni avanzate",
          "DESCRIPTION": "Aggiungi maggiore controllo all’assistente. (Funziona come un flusso: guardrails → scenari → output) Incoraggia a sfruttare al meglio queste impostazioni.",
          "OPTIONS": {
            "GUARDRAILS": {
              "TITLE": "Guardrail",
              "DESCRIPTION": "Mantieni l’assistente concentrato: risponde solo ai tipi di domande che desideri, evitando argomenti fuori tema o non consentiti."
            },
            "RESPONSE_GUIDELINES": {
              "TITLE": "Linee guida per le risposte",
              "DESCRIPTION": "Imposta il tono e la struttura delle risposte del tuo assistente: chiare e amichevoli? Brevi e dirette? Dettagliate e formali?"
            }
          }
        },
        "DELETE": {
          "TITLE": "Elimina Assistente",
          "DESCRIPTION": "Questa azione è permanente. L'eliminazione di questo assistente la rimuoverà da tutte le inbox connesse e cancellerà definitivamente tutte le knowledge generate.",
          "BUTTON_TEXT": "Elimina {assistantName}"
        }
      },
      "OPTIONS": {
        "EDIT_ASSISTANT": "Modifica Assistente",
        "DELETE_ASSISTANT": "Elimina Assistente",
        "VIEW_CONNECTED_INBOXES": "Visualizza inbox connesse"
      },
      "EMPTY_STATE": {
        "TITLE": "Nessun assistente disponibile",
        "SUBTITLE": "Crea un assistente per fornire risposte rapide e accurate agli utenti. Può imparare dagli articoli dell'Help Center e dalle conversazioni passate.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain Assistant",
          "NOTE": "Captain Assistant interagisce direttamente con i clienti, impara dai documenti e dalle conversazioni passate e fornisce risposte rapide e accurate. Gestisce le richieste iniziali, fornendo risoluzioni rapide prima di trasferire ad un operatore quando necessario."
        }
      },
      "GUARDRAILS": {
        "TITLE": "Guardrail",
        "DESCRIPTION": "Mantieni l’assistente concentrato: risponde solo ai tipi di domande che desideri, evitando argomenti fuori tema o non consentiti.",
        "BULK_ACTION": {
          "SELECTED": "{count} elemento selezionato | {count} elementi selezionati",
          "SELECT_ALL": "Seleziona tutto ({count})",
          "UNSELECT_ALL": "Deseleziona tutto ({count})",
          "BULK_DELETE_BUTTON": "Elimina"
        },
        "ADD": {
          "SUGGESTED": {
            "TITLE": "Guardrail di esempio",
            "ADD": "Aggiungi tutto",
            "ADD_SINGLE": "Aggiungi questo",
            "SAVE": "Aggiungi e salva (↵)",
            "PLACEHOLDER": "Digita un altro guardrail..."
          },
          "NEW": {
            "TITLE": "Aggiungi un guardrail",
            "CREATE": "Crea",
            "CANCEL": "Annulla",
            "PLACEHOLDER": "Digita un altro guardrail...",
            "TEST_ALL": "Testa tutto"
          }
        },
        "LIST": {
          "SEARCH_PLACEHOLDER": "Cerca..."
        },
        "EMPTY_MESSAGE": "Nessun guardrail trovato. Crea o aggiungi esempi per iniziare.",
        "SEARCH_EMPTY_MESSAGE": "Nessun guardrail trovato per questa ricerca.",
        "API": {
          "ADD": {
            "SUCCESS": "Guardrail aggiunti correttamente",
            "ERROR": "Si è verificato un errore nell'aggiunta di guardrail, riprova."
          },
          "UPDATE": {
            "SUCCESS": "Guardrail aggiornati con successo",
            "ERROR": "Si è verificato un errore durante l'aggiornamento dei guardrail, riprova."
          },
          "DELETE": {
            "SUCCESS": "Guardrail eliminati con successo",
            "ERROR": "Si è verificato un errore nell'eliminazione dei guardrail, riprova."
          }
        }
      },
      "RESPONSE_GUIDELINES": {
        "TITLE": "Linee Guida per le Risposte",
        "DESCRIPTION": "Imposta il tono e la struttura delle risposte del tuo assistente: chiare e amichevoli? Brevi e dirette? Dettagliate e formali?",
        "BULK_ACTION": {
          "SELECTED": "{count} elemento selezionato | {count} elementi selezionati",
          "SELECT_ALL": "Seleziona tutto ({count})",
          "UNSELECT_ALL": "Deseleziona tutto ({count})",
          "BULK_DELETE_BUTTON": "Elimina"
        },
        "ADD": {
          "SUGGESTED": {
            "TITLE": "Esempio di Linee Guida per le Risposte",
            "ADD": "Aggiungi tutto",
            "ADD_SINGLE": "Aggiungi questo",
            "SAVE": "Aggiungi e salva (↵)",
            "PLACEHOLDER": "Digita un'altra linea guida di risposta..."
          },
          "NEW": {
            "TITLE": "Aggiungi una linea guida per le risposte",
            "CREATE": "Crea",
            "CANCEL": "Annulla",
            "PLACEHOLDER": "Digita un'altra linea guida di risposta...",
            "TEST_ALL": "Testa tutto"
          }
        },
        "LIST": {
          "SEARCH_PLACEHOLDER": "Cerca..."
        },
        "EMPTY_MESSAGE": "Nessuna linea guida per le risposte trovata. Crea o aggiungi esempi per iniziare.",
        "SEARCH_EMPTY_MESSAGE": "Nessuna linea guida per le risposte trovata per questa ricerca.",
        "API": {
          "ADD": {
            "SUCCESS": "Linee guida per le risposte aggiunte correttamente",
            "ERROR": "Si è verificato un errore nell'aggiunta delle linee guida, riprova."
          },
          "UPDATE": {
            "SUCCESS": "Linee guida aggiornate correttamente",
            "ERROR": "Si è verificato un errore durante l'aggiornamento delle linee guida, riprova."
          },
          "DELETE": {
            "SUCCESS": "Linee guida eliminate correttamente",
            "ERROR": "Si è verificato un errore durante l'eliminazione delle linee guida, riprova."
          }
        }
      },
      "SCENARIOS": {
        "TITLE": "Scenari",
        "DESCRIPTION": "Fornisci contesto aggiuntivo al tuo assistente, ad esempio “cosa fare quando un utente è bloccato” o “come comportarsi durante una richiesta di rimborso”.",
        "BULK_ACTION": {
          "SELECTED": "{count} elemento selezionato | {count} elementi selezionati",
          "SELECT_ALL": "Seleziona tutto ({count})",
          "UNSELECT_ALL": "Deseleziona tutto ({count})",
          "BULK_DELETE_BUTTON": "Elimina"
        },
        "ADD": {
          "SUGGESTED": {
            "TITLE": "Scenari di esempio",
            "ADD": "Aggiungi tutto",
            "ADD_SINGLE": "Aggiungi questo",
            "TOOLS_USED": "Strumenti utilizzati:"
          },
          "NEW": {
            "CREATE": "Aggiungi uno scenario",
            "TITLE": "Crea uno scenario",
            "FORM": {
              "TITLE": {
                "LABEL": "Titolo",
                "PLACEHOLDER": "Inserisci un nome per lo scenario",
                "ERROR": "Nome dello scenario richiesto"
              },
              "DESCRIPTION": {
                "LABEL": "Descrizione",
                "PLACEHOLDER": "Descrivi come e dove questo scenario verrà utilizzato",
                "ERROR": "Descrizione dello scenario richiesta"
              },
              "INSTRUCTION": {
                "LABEL": "Come gestire",
                "PLACEHOLDER": "Descrivere come e dove sarà gestito questo scenario",
                "ERROR": "Il contenuto dello scenario è richiesto"
              },
              "CREATE": "Crea",
              "CANCEL": "Annulla"
            }
          }
        },
        "UPDATE": {
          "CANCEL": "Annulla",
          "UPDATE": "Aggiorna le modifiche"
        },
        "LIST": {
          "SEARCH_PLACEHOLDER": "Cerca..."
        },
        "EMPTY_MESSAGE": "Nessun scenario trovato. Crea o aggiungi esempi per iniziare.",
        "SEARCH_EMPTY_MESSAGE": "Nessun scenario trovato per questa ricerca.",
        "API": {
          "ADD": {
            "SUCCESS": "Scenari aggiunti correttamente",
            "ERROR": "Si è verificato un errore durante l'aggiunta degli scenari, riprova."
          },
          "UPDATE": {
            "SUCCESS": "Scenari aggiornati correttamente",
            "ERROR": "Si è verificato un errore durante l'aggiornamento degli scenari, riprova."
          },
          "DELETE": {
            "SUCCESS": "Scenari eliminati correttamente",
            "ERROR": "Si è verificato un errore durante l'eliminazione degli scenari, riprova."
          }
        }
      }
    },
    "DOCUMENTS": {
      "HEADER": "Documenti",
      "ADD_NEW": "Crea un nuovo documento",
      "SELECTED": "{count} selezionate",
      "SELECT_ALL": "Seleziona tutto ({count})",
      "UNSELECT_ALL": "Deseleziona tutto ({count})",
      "BULK_DELETE_BUTTON": "Elimina",
      "BULK_SYNC_BUTTON": "Aggiorna",
      "BULK_DELETE": {
        "TITLE": "Delete documents?",
        "DESCRIPTION": "Are you sure you want to delete the selected documents? This action cannot be undone.",
        "CONFIRM": "Sì, elimina tutte",
        "SUCCESS_MESSAGE": "Documents deleted successfully",
        "ERROR_MESSAGE": "There was an error deleting the documents, please try again."
      },
      "BULK_SYNC": {
        "SUCCESS_MESSAGE_ONE": "Riaggiornamento in coda per 1 documento",
        "SUCCESS_MESSAGE": "Riaggiornamento in coda per {count} documenti",
        "ZERO_MESSAGE": "Nessun documento contrassegnato per il riaggiornamento.",
        "ERROR_MESSAGE": "Si è verificato un errore nella coda di riaggiornamento, riprova."
      },
      "SYNC": {
        "QUEUED_MESSAGE": "Riaggiornamento in coda. Il documento verrà aggiornato a breve.",
        "ERROR_MESSAGE": "Impossibile avviare la coda di riaggiornamento, riprova."
      },
      "FILTERS": {
        "SOURCE": {
          "ALL": "Tutte le fonti",
          "WEB": "Pagine web",
          "PDF": "PDF"
        },
        "STATUS": {
          "ANY": "Tutti gli stati",
          "UPDATED": "Aggiornato",
          "NEEDS_UPDATE": "Richiede aggiornamento",
          "UPDATING": "Aggiornamento in corso",
          "FAILED": "Non Riuscito"
        },
        "SORT": {
          "RECENTLY_UPDATED": "Aggiornato di recente",
          "RECENTLY_CREATED": "Creato di recente"
        },
        "SEARCH_PLACEHOLDER": "Cerca..."
      },
      "SYNC_STATUS": {
        "SYNCED": "ultimo aggiornamento {time}",
        "SYNCING": "aggiornamento...",
        "STALE_SYNC": "update stalled",
        "FAILED": "Sincronizzazione fallita",
        "NEVER_SYNCED": "non ancora aggiornato"
      },
      "SYNC_ERRORS": {
        "NOT_FOUND": "Pagina non trovata",
        "ACCESS_DENIED": "Accesso negato",
        "TIMEOUT": "La pagina ha impiegato troppo tempo per rispondere",
        "CONTENT_EMPTY": "La pagina ha restituito contenuto vuoto",
        "FETCH_FAILED": "Impossibile recuperare la pagina",
        "SYNC_ERROR": "Errore imprevisto",
        "DEFAULT": "Errore di sincronizzazione"
      },
      "RELATED_RESPONSES": {
        "TITLE": "FAQ Correlate",
        "DESCRIPTION": "Queste FAQ vengono generate direttamente dai Documenti."
      },
      "FORM_DESCRIPTION": "Inserisci l'URL del documento per aggiungerlo come fonte e scegli l'assistente con cui associarlo.",
      "CREATE": {
        "TITLE": "Aggiungi un documento",
        "SUCCESS_MESSAGE": "Il documento è stato creato correttamente",
        "ERROR_MESSAGE": "Si è verificato un errore durante la creazione del documento, riprova."
      },
      "FORM": {
        "TYPE": {
          "LABEL": "Tipo di Documento",
          "URL": "URL",
          "PDF": "File PDF"
        },
        "URL": {
          "LABEL": "URL",
          "PLACEHOLDER": "Inserisci l'URL del documento",
          "ERROR": "Inserisci un URL valido per il documento"
        },
        "PDF_FILE": {
          "LABEL": "File PDF",
          "CHOOSE_FILE": "Seleziona file PDF",
          "ERROR": "Seleziona un file PDF",
          "HELP_TEXT": "Dimensione massima del file: 10MB",
          "INVALID_TYPE": "Seleziona un file PDF valido",
          "TOO_LARGE": "La dimensione del file supera il limite di 10MB"
        },
        "NAME": {
          "LABEL": "Nome Documento (Opzionale)",
          "PLACEHOLDER": "Inserisci un nome per il documento"
        }
      },
      "DELETE": {
        "TITLE": "Sei sicuro di voler eliminare il documento?",
        "DESCRIPTION": "Questa azione è permanente. L'eliminazione di questo documento cancellerà definitivamente tutte le conoscenze generate.",
        "CONFIRM": "Sì, elimina",
        "SUCCESS_MESSAGE": "Il documento è stato eliminato con successo",
        "ERROR_MESSAGE": "Si è verificato un errore durante l'eliminazione del documento, riprova."
      },
      "OPTIONS": {
        "VIEW_RELATED_RESPONSES": "Visualizza FAQ Correlate",
        "SYNC_NOW": "Aggiorna ora",
        "RETRY_SYNC": "Riprova ad aggiornare",
        "DELETE_DOCUMENT": "Elimina Documento"
      },
      "EMPTY_STATE": {
        "TITLE": "Nessun documento disponibile",
        "SUBTITLE": "I documenti sono utilizzati dal tuo assistente per generare FAQ. Puoi importare documenti per fornire contesto al tuo assistente.",
        "FILTERED_TITLE": "Nessun documento corrispondente",
        "FILTERED_SUBTITLE": "Prova a cambiare fonte, stato o chiave di ricerca.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Documento Captain",
          "NOTE": "Un documento in Captain serve come risorsa di knowledge base per l'assistente. Collegando documenti help center e guide, Captain può analizzare il contenuto e fornire risposte accurate per le richieste dei clienti."
        }
      }
    },
    "CUSTOM_TOOLS": {
      "HEADER": "Strumenti",
      "ADD_NEW": "Crea un nuovo strumento",
      "SOFT_LIMIT_WARNING": "Having more than 10 tools may reduce the assistant's reliability in selecting the right tool. Consider removing unused tools for better results.",
      "EMPTY_STATE": {
        "TITLE": "Nessuno strumento personalizzato disponibile",
        "SUBTITLE": "Crea strumenti personalizzati per collegare il tuo assistente con API e servizi esterni, consentendogli di recuperare dati ed eseguire azioni per tuo conto.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Strumenti Personalizzati",
          "NOTE": "Gli strumenti personalizzati consentono all'assistente di interagire con API e servizi esterni. Crea strumenti per recuperare dati, eseguire azioni o integrare con i sistemi esistenti per migliorare le capacità del tuo assistente."
        }
      },
      "FORM_DESCRIPTION": "Configura il tuo strumento personalizzato per connetterti con API esterne",
      "OPTIONS": {
        "EDIT_TOOL": "Modifica strumento",
        "DELETE_TOOL": "Elimina strumento"
      },
      "CREATE": {
        "TITLE": "Crea Strumento Personalizzato",
        "SUCCESS_MESSAGE": "Strumento personalizzato creato correttamente",
        "ERROR_MESSAGE": "Impossibile creare uno strumento personalizzato"
      },
      "EDIT": {
        "TITLE": "Modifica Strumento Personalizzato",
        "SUCCESS_MESSAGE": "Strumento personalizzato aggiornato correttamente",
        "ERROR_MESSAGE": "Impossibile aggiornare strumento personalizzato"
      },
      "DELETE": {
        "TITLE": "Elimina Strumento Personalizzato",
        "DESCRIPTION": "Sei sicuro di voler eliminare questo strumento personalizzato? Questa azione non può essere annullata.",
        "CONFIRM": "Sì, elimina",
        "SUCCESS_MESSAGE": "Strumento personalizzato eliminato correttamente",
        "ERROR_MESSAGE": "Impossibile eliminare lo strumento personalizzato"
      },
      "PAYWALL": {
        "TITLE": "Aggiorna per utilizzare gli strumenti con Captain",
        "AVAILABLE_ON": "Gli strumenti Captain sono disponibili solo nei piani Business e Enterprise. Si prega di aggiornare al piano Business per utilizzare la funzionalità.",
        "UPGRADE_PROMPT": "",
        "UPGRADE_NOW": "Apri fatturazione",
        "CANCEL_ANYTIME": ""
      },
      "ENTERPRISE_PAYWALL": {
        "AVAILABLE_ON": "Gli strumenti Captain sono disponibili solo nei piani a pagamento.",
        "UPGRADE_PROMPT": "Aggiorna a un piano a pagamento per utilizzare questa funzione.",
        "ASK_ADMIN": "Contatta il tuo amministratore per l'aggiornamento."
      },
      "TEST": {
        "BUTTON": "Test connection",
        "SUCCESS": "Endpoint returned HTTP {status}",
        "ERROR": "Connection failed",
        "DISABLED_HINT": "Testing is only available for endpoints without templates or request bodies."
      },
      "FORM": {
        "TITLE": {
          "LABEL": "Nome Strumento",
          "PLACEHOLDER": "Ricerca Ordini",
          "ERROR": "Nome strumento richiesto",
          "MAX_LENGTH_ERROR": "Tool name must be {max} characters or fewer"
        },
        "DESCRIPTION": {
          "LABEL": "Descrizione",
          "PLACEHOLDER": "Cerca i dettagli di un ordine tramite l'ID ordine"
        },
        "HTTP_METHOD": {
          "LABEL": "Metodo"
        },
        "ENDPOINT_URL": {
          "LABEL": "Endpoint URL",
          "PLACEHOLDER": "https://api.example.com/orders/{'{{'} order_id {'}}'}",
          "ERROR": "È richiesto un URL valido"
        },
        "AUTH_TYPE": {
          "LABEL": "Tipo di Autenticazione"
        },
        "AUTH_TYPES": {
          "NONE": "Nessuno",
          "BEARER": "Bearer Token",
          "BASIC": "Autenticazione Base",
          "API_KEY": "Chiave API"
        },
        "AUTH_CONFIG": {
          "BEARER_TOKEN": "Bearer Token",
          "BEARER_TOKEN_PLACEHOLDER": "Inserisci il tuo Bearer Token",
          "USERNAME": "Nome Utente",
          "USERNAME_PLACEHOLDER": "Inserisci il nome utente",
          "PASSWORD": "Password",
          "PASSWORD_PLACEHOLDER": "Inserire la password",
          "API_KEY": "Nome Header",
          "API_KEY_PLACEHOLDER": "X-API-Key",
          "API_VALUE": "Valore Header",
          "API_VALUE_PLACEHOLDER": "Inserisci valore chiave API"
        },
        "PARAMETERS": {
          "LABEL": "Parametri",
          "HELP_TEXT": "Definisci i parametri che verranno estratti dalle query utente"
        },
        "ADD_PARAMETER": "Aggiungi Parametro",
        "PARAM_NAME": {
          "PLACEHOLDER": "Nome del parametro (es. order_id)"
        },
        "PARAM_TYPE": {
          "PLACEHOLDER": "Tipo"
        },
        "PARAM_TYPES": {
          "STRING": "Stringa",
          "NUMBER": "Numero",
          "BOOLEAN": "Boolean",
          "ARRAY": "Array",
          "OBJECT": "Oggetto"
        },
        "PARAM_DESCRIPTION": {
          "PLACEHOLDER": "Descrizione del parametro"
        },
        "PARAM_REQUIRED": {
          "LABEL": "Richiesto"
        },
        "REQUEST_TEMPLATE": {
          "LABEL": "Request Body Template (Opzionale)",
          "PLACEHOLDER": "{'{'}\n  \"order_id\": \"{'{{'} order_id {'}}'}\"\n{'}'}"
        },
        "RESPONSE_TEMPLATE": {
          "LABEL": "Response Template (Opzionale)",
          "PLACEHOLDER": "Order {'{{'} order_id {'}}'} status: {'{{'} status {'}}'}"
        },
        "ERRORS": {
          "PARAM_NAME_REQUIRED": "Nome del parametro richiesto"
        }
      }
    },
    "RESPONSES": {
      "HEADER": "FAQ",
      "PENDING_FAQS": "FAQ In Attesa",
      "ADD_NEW": "Crea nuova FAQ",
      "DOCUMENTABLE": {
        "CONVERSATION": "Conversazione #{id}"
      },
      "SELECTED": "{count} selezionate",
      "SELECT_ALL": "Seleziona tutto ({count})",
      "UNSELECT_ALL": "Deseleziona tutto ({count})",
      "SEARCH_PLACEHOLDER": "Cerca FAQ...",
      "BULK_APPROVE_BUTTON": "Approva",
      "BULK_DELETE_BUTTON": "Elimina",
      "BULK_APPROVE": {
        "SUCCESS_MESSAGE": "FAQ approvate con successo",
        "ERROR_MESSAGE": "Si è verificato un errore nell'approvazione delle FAQ, riprova."
      },
      "BULK_DELETE": {
        "TITLE": "Eliminare FAQ?",
        "DESCRIPTION": "Sei sicuro di voler eliminare le FAQ selezionate? Questa azione non può essere annullata.",
        "CONFIRM": "Sì, elimina tutte",
        "SUCCESS_MESSAGE": "FAQ eliminate con successo",
        "ERROR_MESSAGE": "Si è verificato un errore durante l'eliminazione delle FAQ, riprova."
      },
      "DELETE": {
        "TITLE": "Sei sicuro di voler eliminare la FAQ?",
        "DESCRIPTION": "",
        "CONFIRM": "Sì, elimina",
        "SUCCESS_MESSAGE": "FAQ eliminata con successo",
        "ERROR_MESSAGE": "Si è verificato un errore durante l'eliminazione della FAQ, riprova."
      },
      "FILTER": {
        "ASSISTANT": "Assistente: {selected}",
        "STATUS": "Stato: {selected}",
        "ALL_ASSISTANTS": "Tutti"
      },
      "STATUS": {
        "TITLE": "Stato",
        "PENDING": "In Sospeso",
        "APPROVED": "Approvate",
        "ALL": "Tutte"
      },
      "PENDING_BANNER": {
        "TITLE": "Captain ha trovato delle FAQ tra le domande dei tuoi clienti.",
        "ACTION": "Clicca qui per rivedere"
      },
      "FORM_DESCRIPTION": "Aggiungi una domanda e la sua risposta corrispondente alla knowledge base e seleziona l'assistente con cui dovrebbe essere associata.",
      "CREATE": {
        "TITLE": "Aggiungi una FAQ",
        "SUCCESS_MESSAGE": "La risposta è stata aggiunta con successo.",
        "ERROR_MESSAGE": "Si è verificato un errore durante l'aggiunta della risposta. Riprova."
      },
      "FORM": {
        "QUESTION": {
          "LABEL": "Domanda",
          "PLACEHOLDER": "Inserisci qui la domanda",
          "ERROR": "Inserisci una domanda valida."
        },
        "ANSWER": {
          "LABEL": "Risposta",
          "PLACEHOLDER": "Inserisci qui la risposta",
          "ERROR": "Inserisci una risposta valida."
        }
      },
      "EDIT": {
        "TITLE": "Aggiorna FAQ",
        "SUCCESS_MESSAGE": "Le FAQ sono state aggiornate correttamente",
        "ERROR_MESSAGE": "Si è verificato un errore durante l'aggiornamento delle FAQ, riprova",
        "APPROVE_SUCCESS_MESSAGE": "La FAQ è stata contrassegnata come approvata"
      },
      "OPTIONS": {
        "APPROVE": "Approva",
        "EDIT_RESPONSE": "Modifica",
        "DELETE_RESPONSE": "Elimina"
      },
      "EMPTY_STATE": {
        "TITLE": "Nessuna FAQ Trovata",
        "NO_PENDING_TITLE": "Non ci sono più FAQ in attesa da rivedere",
        "SUBTITLE": "Le FAQ aiutano il tuo assistente a fornire risposte rapide e accurate alle domande dei tuoi clienti. Possono essere generate automaticamente dai tuoi contenuti o possono essere aggiunte manualmente.",
        "CLEAR_SEARCH": "Rimuovi filtri attivi",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain FAQ",
          "NOTE": "Captain FAQ rileva le domande più frequenti dei clienti, anche se mancano dalla tua knowledge base, e suggerisce delle FAQ per migliorare il supporto. È possibile rivedere ogni suggerimento e decidere se approvarlo o rifiutarlo."
        }
      }
    },
    "INBOXES": {
      "HEADER": "Inbox Connesse",
      "ADD_NEW": "Collega una nuova inbox",
      "OPTIONS": {
        "DISCONNECT": "Disconnetti"
      },
      "DELETE": {
        "TITLE": "Sei sicuro di voler disconnettere la inbox?",
        "DESCRIPTION": "",
        "CONFIRM": "Sì, elimina",
        "SUCCESS_MESSAGE": "Inbox disconnessa con successo.",
        "ERROR_MESSAGE": "Si è verificato un errore durante la disconnessione della inbox, riprova."
      },
      "FORM_DESCRIPTION": "Scegli una inbox da connettere all'assistente.",
      "CREATE": {
        "TITLE": "Connetti una Inbox",
        "SUCCESS_MESSAGE": "Inbox connessa con successo.",
        "ERROR_MESSAGE": "Si è verificato un errore durante la connessione della inbox. Riprova."
      },
      "FORM": {
        "INBOX": {
          "LABEL": "Inbox",
          "PLACEHOLDER": "Scegli la inbox in cui deployare l'assistente.",
          "ERROR": "È richiesta una inbox."
        }
      },
      "EMPTY_STATE": {
        "TITLE": "Nessuna Inbox Connessa",
        "SUBTITLE": "Connettendo una inbox, l'assistente potrà gestire le richieste iniziali dei clienti, ed eventualmente trasferirle a voi."
      }
    }
  }
}
